// Set this environment variable to true to enable local development route validation, you can do this by adding the following flags to your build or dev command:
// yarn next dev --enable-local-route-validation | - e
// OR yarn next build-start --enable-local-route-validation | - e
// You can also test this locally in aem-spa by running the following command:
// yarn aem-spa start --enable-local-route-validation | - e
// OR yarn aem-spa dev --enable-local-route-validation | - e
// this will allow for testing the enabledRoutes logic locally (the applicaton will trigger a page reload if the route is not enabled)
/**
 * Determines if local route validation is enabled based on the environment variable.
 *
 * @returns {boolean} - Returns true if local route validation is enabled, otherwise false.
 */
const isLocalRouteValidationEnabled = (): boolean =>
  process.env.REACT_APP_ENABLE_LOCAL_DEV_ROUTE_VALIDATION === "true" ||
  process.env.NEXT_PUBLIC_ENABLE_LOCAL_DEV_ROUTE_VALIDATION === "true"

export default isLocalRouteValidationEnabled
